import type { FC, PropsWithChildren } from 'react';
import { ThemeProvider, Toaster } from '@ui';
import dayjs from 'dayjs';
import dayjsDuration from 'dayjs/plugin/duration';
import dayjsTimezone from 'dayjs/plugin/timezone';
import dayjsUTC from 'dayjs/plugin/utc';
import 'dayjs/locale/ru';

dayjs.extend(dayjsUTC);
dayjs.extend(dayjsDuration);
dayjs.extend(dayjsTimezone);

export const Wrapper: FC<PropsWithChildren> = ({ children }) => (
    <ThemeProvider>
        {children}
        <Toaster />
    </ThemeProvider>
);
